// Tawk.to Configuration
// Knowledge Base URL: https://ravahcarbon.tawk.help
// Ticketing Email Format: tickets+[ticket-id]@ravahcarbon.p.tawkto.email
export const TAWK_TO_CONFIG = {
  widgetId: 'ravahcarbon', // Your Tawk.to widget ID
  knowledgeBaseUrl: 'https://ravahcarbon.tawk.help',
  supportUrl: 'https://ravahcarbon.tawk.help',
  ticketingEmailDomain: 'ravahcarbon.p.tawkto.email', // Tawk.to ticketing email domain
  ticketingEmailPrefix: 'tickets', // Email prefix for tickets
};

// Helper function to open Tawk.to support
export const openTawkToSupport = () => {
  window.open(TAWK_TO_CONFIG.supportUrl, '_blank');
};
